import { JumboRadioProps } from '@tlx/beehive-shared';
import { Children, cloneElement, ReactElement } from 'react';

export function JumboRadioGroup({
    children,
    name,
}: {
    children: ReactElement<JumboRadioProps> | ReactElement<JumboRadioProps>[];
    name: string;
}) {
    return (
        <fieldset id={`Radio-Group-${name}`} className="atl-fieldset atl-flex atl-flex-col atl-gap-8">
            {Children.map(children, (child) => {
                const testId = `${name}-${child.props.value}-radio`;
                return cloneElement(child, {
                    className: `${child.props.className} atl-justify-between`,
                    name,
                    'data-trackingid': child.props['data-trackingid'] ?? testId,
                });
            })}
        </fieldset>
    );
}
